module.exports = __webpack_public_path__ + "static/media/roo.86dcd682.ogg";